import React from "react";
import { Box } from "@material-ui/core";
import useStyles from "../TransactionCard/styles";
import { Skeleton } from "@material-ui/lab";

function TransactionSkeletonCard() {
  const styles = useStyles();

  return (
    <Box className={styles.unitCard}>
      <Box position="relative" className={styles.imageWrapper}>
        <Skeleton
          variant="rect"
          width="100%"
          height={240}
          className={styles.unitImage}
        />
        <Skeleton
          variant="rect"
          width={160}
          height={28}
          style={{
            position: "absolute",
            bottom: 12,
            left: 12,
            borderRadius: 8,
          }}
        />
        <Skeleton
          variant="rect"
          width={80}
          height={28}
          style={{ position: "absolute", top: 12, right: 12, borderRadius: 8 }}
        />
      </Box>
      <Box className={styles.details}>
        <Box display={"flex"} flexDirection={"column"} gridGap={8}>
          <Box display="flex" gridGap={8} >
            <Skeleton variant="text" width={60} height={24} />
            <Skeleton
              variant="rect"
              width={40}
              height={28}
              style={{ borderRadius: 8 }}
            />
          </Box>
          <Skeleton variant="text" width={160} height={28} />
          <Skeleton variant="text" width={180} height={20} />
        </Box>
        <Box className={styles.body}>
          <Box className={styles.unitDetails}>
            <Skeleton
              variant="rect"
              width={40}
              height={28}
              style={{ borderRadius: 8 }}
            />
            <Skeleton
              variant="rect"
              width={40}
              height={28}
              style={{ borderRadius: 8 }}
            />
            <Skeleton
              variant="rect"
              width={40}
              height={28}
              style={{ borderRadius: 8 }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default TransactionSkeletonCard;
